/* global globalThis */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { T } from '~/components/Translations';
import { ApiUrl } from '../../../project/Defines.js';
import { EVENT_NAME } from '~/project/utilities.js';
import ListView from '~/Shared/ListView';
import { COLUMN_TYPE } from '~/Shared/ListView/helper';
import { PopupTypes } from '../../../components/Popup';
import { openPopup } from '../../../store/actions';




/**
 * the societe List
 * @exports EquipmentCardPicker
 */
function EquipmentCardPicker(props) {
    const listUpdateEvent = EVENT_NAME.SERVICE_CALL_LIST_UPDATE;
    const { internal_serial_number, onClose, setDataItem, duplicateData, loadInstallerBySerialNumber } = props;
    const [detailProps] = useState({
        windowKey: 'wndEquipmentCardCreate',
        popupType: PopupTypes.EquipmentCardEdit,
        fullScreen: false,
        listUpdateEvent,
        internal_serial_number,
        isPickupEdit: true,
        duplicateDataItem: duplicateData
    });

    const [isMobile, setIsMobile] = useState(globalThis.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(globalThis.innerWidth <= 768);
        };
        
        globalThis.addEventListener('resize', handleResize);
        return () => globalThis.removeEventListener('resize', handleResize);
      }, []);

    /** //const openEquipmentCardCreate = useCallback(() => {
        //    openPopup({
        //        windowKey: 'wndEquipmentCardCreate',
        //        title: <T>text.new_equipment_card</T>,
        //        type: PopupTypes.EquipmentCardCreate,
        //        className: PopupClasses.Large,
        //        fullScreen: false,
        //        bodyProps: { internal_serial_number, listUpdateEvent },
        //    });
        //}, [internal_serial_number, listUpdateEvent, openPopup]); */
    const onLoaded = (data) => {
        return data.map(card => {
            const index = card.OwnerName.indexOf('|');
            card.OwnerCode = card.OwnerName.slice(0, index);
            if (index !== -1) {
                card.OwnerName = card.OwnerName.slice(index + 1);
            }
            return card;
        });
    };

    const onSelect = (record) => {
        setDataItem(item => ({
            ...item,
            code_product: record.CodeCom,
            product_code: record.CodeCom,
            item_code: record.ItemCode,
            internal_serial_number: record.InternalSN,
            customer_code: record.OwnerCode
        }));

        if (loadInstallerBySerialNumber) {
            loadInstallerBySerialNumber(record.InternalSN);
        }
        onClose();
    };
    const columnConfig = [
        {
            text: 'text.serial_number',
            field: 'InternalSN',
            type: COLUMN_TYPE.TEXT,
            noSort: true,
            width: 200,
            fixed: (isMobile ? "" : 'left')
        },
        {
            text: 'text.product',
            field: 'CodeCom',
            type: COLUMN_TYPE.TEXT,
            noSort: true,
            width: 300,
            render: (t, record) => {
                const text = [
                    record.CodeCom,
                    record.ItemName
                ].filter(x => !!x).join(' - ');
                return <wrap title={text} >
                    <text>{text}</text>
                </wrap>;
            }
        },
        {
            text: 'text.customer_name',
            field: 'OwnerName',
            width: 230,
            type: COLUMN_TYPE.TEXT,
            noSort: true
        },
        {
            text: 'text.address',
            field: 'Street',
            type: COLUMN_TYPE.TEXT,
            noSort: true,
            width: 250,
            render: (t, record) => {
                const text = [
                    record.Street,
                    record.City,
                    record.Zip,
                    record.Country
                ].filter(x => !!x).join(', ');
                return <wrap title={text} >
                    <text>{text}</text>
                </wrap>;
            }
        },
        {
            type: COLUMN_TYPE.CUSTOM,
            width: 100,
            fixed: 'right',
            render: (text, record) => <elastic>
                <action hover=""
                >
                    <div
                        effect="material"
                        className="button accent"
                        onClick={() => onSelect(record)}
                    >
                        <text><T>text.select</T></text>
                    </div>
                </action>
            </elastic>
        },
        {
            fixed: 'right',
            type: COLUMN_TYPE.ACTION
        }
    ];

    return (
        <ListView
            {...props}
            isSimple
            className={`scroll_fix ${isMobile ? "visible_buttons" : ""}`}
            // className={'scroll_fix'}
            columnConfig={columnConfig}
            apiUrl={ApiUrl.EquipmentCardList}
            staticFilter={{ internal_serial_number }}
            keyField='InsId'
            // onNewClick={openEquipmentCardCreate}
            listUpdateEvent={listUpdateEvent}
            detailProps={detailProps}
            onLoaded={onLoaded}
        />
    );
}

EquipmentCardPicker.propTypes = {
    internal_serial_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClose: PropTypes.func.isRequired,
    setDataItem: PropTypes.func.isRequired,
    duplicateData: PropTypes.object,
    loadInstallerBySerialNumber: PropTypes.func
};

export default connect(null, dispatch => ({ openPopup: (props) => dispatch(openPopup(props)) }))(EquipmentCardPicker);